import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IpRefreshService {

  constructor() { }
  private headerMessage: string = "";
  private popupContent: string = "";
  private error: boolean = true;

  private custIDs: any = '';
  private subject = new Subject<any>();
  private ipRefreshSearch: Subject<any> = new Subject<any>();

  setPopupDetails(headerMessage, popupContent, error) {
    this.headerMessage = headerMessage;
    this.popupContent = popupContent;
    this.error = error;
  }

  getPopupDetails() {
    return {"headerMessage": this.headerMessage, "popupContent": this.popupContent, "error": this.error};
  }

  setCustomerDetails(custIDs) {
    this.custIDs = custIDs;
  }

  getCustomerDetails() {
    return this.custIDs;
  }

  
  queueCustomerPopup() {
    this.subject.next();
  }

  getCustomerPopup(): Observable<any> {
    return this.subject.asObservable();
  }

  queueFilesRefresh() {
    this.ipRefreshSearch.next();
  }

  getFilesRefresh(): Observable<any> {
    return this.ipRefreshSearch.asObservable();
  }
}
